var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=linkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48701 2.28955C3.39133 2.28955 2.49995 3.17997 2.49995 4.27444C2.49995 5.36939 3.39133 6.26015 4.48701 6.26015C5.58182 6.26015 6.47248 5.36934 6.47248 4.27444C6.47253 3.17997 5.58182 2.28955 4.48701 2.28955ZM5.9915 7.0987H2.98022C2.84658 7.0987 2.73829 7.20704 2.73829 7.34064V17.0146C2.73829 17.1482 2.84658 17.2565 2.98022 17.2565H5.9915C6.12514 17.2565 6.23343 17.1482 6.23343 17.0146V7.34064C6.23343 7.20704 6.12514 7.0987 5.9915 7.0987ZM11.0051 7.96894C11.5474 7.37818 12.4414 6.85826 13.6509 6.85826C17.0426 6.85826 17.4999 9.30999 17.4999 11.7083V17.0146C17.4999 17.1483 17.3916 17.2565 17.2579 17.2565H14.2521C14.1185 17.2565 14.0102 17.1483 14.0102 17.0146V12.3112C14.0102 10.9943 13.9129 9.98697 12.6884 9.98697C11.5641 9.98697 11.126 10.6153 11.126 12.2282V17.0146C11.126 17.1482 11.0177 17.2565 10.8841 17.2565H7.87936C7.74572 17.2565 7.63743 17.1482 7.63743 17.0146V7.34063C7.63743 7.20704 7.74572 7.0987 7.87936 7.0987H10.7632C10.8968 7.0987 11.0051 7.20704 11.0051 7.34063V7.96894Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4efe24321845af49e7f198f2095292c1.svg";
export { ForwardRef as ReactComponent };